// extracted by mini-css-extract-plugin
export default {"songsSection":"SongsSection_songsSection__-W+XE","title":"SongsSection_title__dB8sE","titleDiv":"SongsSection_titleDiv__GcSYT","gridDiv":"SongsSection_gridDiv__4npNX"};